app.views.marketingPreferences = app.views.base.extend({
  childEvents: {
    'click [data-preference]': 'toggleMarketingPreferences',
    'click [data-update-marketing-preferences]': 'showSpinners',
    'click [data-skip-marketing-preferences]': 'showSpinners'
  },
  attr: {
    updateMarketingPreferences: 'data-update-marketing-preferences',
    preference: 'data-preference'
  },
  classes: {
    disabled: 'disabled',
    header: 'header',
    navigation: 'header-nav',
    footer: 'footer',
    actions: 'header-actions',
    pageSpinner: 'page-spinner'
  },
  init: function init() {
    $('.' + this.classes.header).hide();
    $('.' + this.classes.navigation).hide();
    $('.' + this.classes.footer).hide();
    $('.' + this.classes.actions).hide();
  },
  toggleMarketingPreferences: function toggleMarketingPreferences(e) {
    var preferencesChecked = $('[' + this.attr.preference + ']:checked').length;
    if (preferencesChecked === 0) {
      $('[' + this.attr.updateMarketingPreferences + ']').addClass(this.classes.disabled);
      $('[' + this.attr.updateMarketingPreferences + ']').attr(this.classes.disabled, true);
    } else {
      $('[' + this.attr.updateMarketingPreferences + ']').removeClass(this.classes.disabled);
      $('[' + this.attr.updateMarketingPreferences + ']').removeAttr(this.classes.disabled);
    }
  },
  showSpinners: function showSpinners() {
    var spinner = $('.' + this.classes.pageSpinner);
    if (spinner) {
      spinner.show();
    }
  }
});